import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white">Visiomed Eletromedicina Ltda</h3>
            <p className="text-gray-400 text-sm">
              Vendas e serviços de manutenção de equipamentos de diagnóstico por imagem.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Links Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/equipment" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Equipamentos
                </Link>
              </li>
              <li>
                <Link to="/sales" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Vendas
                </Link>
              </li>
              <li>
                <Link to="/rental" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Locação
                </Link>
              </li>
              <li>
                <Link to="/maintenance" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Manutenção
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Nossos Serviços</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Vendas de Equipamentos</li>
              <li>Locação de Equipamentos</li>
              <li>Manutenção Preventiva</li>
              <li>Manutenção Corretiva</li>
              <li>Consultoria</li>
              <li>Suporte Técnico</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Entre em Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-blue-400 mt-1 flex-shrink-0" />
                <div className="text-gray-400 text-sm">
                  <p>+55 31 3482-8808</p>
                  <p>+55 31 98454-3225</p>
                  <p>+55 31 98454-2800</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-blue-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">visiomed@visiomed.com.br</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-blue-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">Rua João Gualberto Filho 361<br/>Bairro Sagrada Família<br/>Belo Horizonte/MG</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Visiomed Eletromedicina Ltda. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};